<template>
  <transition name="modal">
    <div class="modal-mask">
      <a
        class="modal-close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <img
          :src="asset('/images/close.png')"
          width="35px"
        > </a>

      <div class="modal-wrapper">
        <div
          class="modal-container"
          v-if="status === 'initial'"
        >
          <div class="modal-header">
            <h4 class="modal-title">
              New password
            </h4>
          </div>

          <div class="modal-body">
            <p>Enter your email address below and an email will be sent to you with instructions on how to update your password.</p>
            <form
              id="resetPasswordForm"
              class="form-horizontal"
              role="form"
              method="POST"
              @submit.prevent="postResetPassword"
            >
              <span v-text="response" />
              <div
                class="form-group"
                :class="errors.email ? ' has-error' : ''"
              >
                <div class="col-md-12">
                  <input
                    id="reset-email"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="Email address"
                    v-model="email"
                    autofocus
                  >
                </div>

                <span
                  class="help-block"
                  v-if="errors.email"
                  :errors="errors.email"
                >
                  <span
                    v-for="error in errors.email"
                    :key="error"
                  >{{ error }}</span>
                </span>
              </div>
            </form>
          </div>

          <div class="modal-footer full-width">
            <div class="col-md-6">
              <button
                id="postResetPassword"
                type="submit"
                @click.prevent="postResetPassword"
                class="btn btn-success btn-lg btn-block"
              >
                Send
              </button>
            </div>
            <div class="col-md-6">
              <button
                type="button"
                class="btn btn-danger btn-lg btn-block"
                @click="$emit('close')"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div
          class="modal-container"
          v-if="status === 'sent'"
        >
          <div class="modal-header">
            <h4 class="modal-title">
              Email sent
            </h4>
          </div>
          <div class="modal-body">
            <p>Please check your email for instructions on how to reset your password.</p>
          </div>

          <div class="modal-footer full-width">
            <div class="col-md-6">
              <button
                type="button"
                class="btn btn-success btn-lg btn-block"
                @click="$emit('close')"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
module.exports = {
  name: 'forgotPassword',

  data: function () {
    return {
      response: '',
      errors: [],
      email: '',
      password: '',
      status: 'initial'
    }
  },
  methods: {
    postResetPassword: function () {
      var self = this
      self.response = ''
      self.errors = []

      //  password reset using email
      this.$parent.callAPI('POST', '/password/email', {
        email: self.email
      })
        .then(function (response) {
          self.status = 'sent'
          self.response = 'Please check the instructions sent by email to reset the password.'
        }, error => {
          // error
          if (error.response.status === 422) {
            self.errors = error.response.data.errors
          } else {
            self.response = 'Did not receive a response. Please try again in a few minutes'
          }
        })
    }
  }
}
</script>
